export default __webpack_public_path__ + "static/media/bradesco-logo.f34c29bb.svg";